import { EventProperties } from '~/libs/analytics/types/EventProperties';

const eventPropertiesHasUndefinedValue = (
  eventProperties: Partial<EventProperties>,
): boolean => {
  return Object.values(eventProperties).some((value) => value === undefined);
};

export default eventPropertiesHasUndefinedValue;
